<template>
  <div class="main" v-if="bkmenu">
    <!-- {{ bkmenu.menuitem }} -->

    <van-row>
      <van-col span="12" align="left" class="label">餐點</van-col>
      <van-col span="12" align="right">
        <el-checkbox v-model="chkPosField">POS欄位</el-checkbox>
        <el-divider direction="vertical" />
        <el-checkbox v-model="chkEditMode">編輯模式</el-checkbox>
        <el-divider direction="vertical" />
        <el-button type="primary" @click="cmdSave">儲存</el-button>
      </van-col>
    </van-row>
    <van-divider />

    <el-input v-model="keyword" placeholder="搜尋：編號或名稱" />
    <!-- <el-button @click="cmdAdd()">新增餐點</el-button> -->
    <el-table :data="getFilter()" stripe style="width: 100%">
      <el-table-column
        prop="TypeNo"
        label="類"
        width="50"
        v-if="chkPosField"
      ></el-table-column>
      <el-table-column label="名稱" width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="cmdEdit(scope.$index, scope.row)">
            {{ scope.row.ItemName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="Price1" label="價格" width="80"></el-table-column>
      <el-table-column
        prop="KPtype"
        label="廚別"
        width="80"
        v-if="chkPosField"
      ></el-table-column>
      <el-table-column prop="ItemCode" label="代碼" v-if="chkPosField"></el-table-column>
      <el-table-column label="類別">
        <template slot-scope="scope">
          <!-- {{ scope.row.TypeNo }} -->
          {{ getTypeName(scope.row) }}
          <!-- <el-input v-model="getTypeName(scope.row)" align="right"></el-input> -->
        </template>
      </el-table-column>
      <el-table-column label="標籤" width="200">
        <template slot-scope="scope">
          <el-tag v-for="(r, index) in findExtitem(scope.row).tags" :key="index">{{
            r
          }}</el-tag>
          <!-- {{ scope.row.TypeNo }} -->
          <!-- <el-input v-model="findExtitem(scope.row).tags"></el-input> -->
          <!-- <el-input v-model="getTypeName(scope.row)" align="right"></el-input> -->
        </template>
      </el-table-column>
      <el-table-column label="包含群組">
        <template slot-scope="scope">
          <!-- {{ scope.row.TypeNo }} -->
          <!-- {{ findExtitem(scope.row).groups }} -->
          <div v-if="chkEditMode">
            <el-input v-model="findExtitem(scope.row).groups"></el-input>
          </div>
          <div v-else>
            {{ findExtitem(scope.row).groups }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="包含">
        <template slot-scope="scope">
          {{ getItemGroups(scope.row) }}
        </template>
      </el-table-column> -->
      <el-table-column label="imgfile" width="100">
        <template slot-scope="scope">
          <!-- {{ scope.row.TypeNo }} -->
          <!-- {{ getImgFile(scope.row) }} -->
          <van-image :src="getImgFile(scope.row)" width="80" lazy-load />
        </template>
      </el-table-column>
      <!-- <el-table-column prop="ImgFile" label="圖片"></el-table-column> -->
      <!-- <el-table-column label="選圖">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="$refs.rImagePick.show(scope.row)"
            >選擇</el-button
          >
        </template>
      </el-table-column> -->

      <el-table-column align="right" width="80">
        <template slot-scope="scope">
          <el-button
            size="large"
            circle
            icon="el-icon-document"
            @click="cmdShowDetail(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-backtop />
    <ImagePick ref="rImagePick" @pick="onPick" />
    <FrmEditItem ref="rEditItem" @ok="refresh" />
    <FrmItemDetail ref="rFrmItemDetail" />
  </div>
</template>

<style scoped>
.label {
  font-size: 2rem;
  font-weight: bold;
}
.main {
  padding: 1rem;
  text-align: left;
}
.el-input {
  width: 200;
}
.el-tag {
  margin: 0.2rem;
}
</style>

<script>
export default {
  async mounted() {
    await this.refresh();
  },
  // props: {
  //   bkmenu: Object,
  // },
  data() {
    return {
      bkmenu: null,
      chkEditMode: false,
      chkPosField: false,
      keyword: "",
    };
  },
  methods: {
    findExtitem(obj) {
      var find = this.bkmenu.extitem.find((r) => r.itemname == obj.ItemName);
      if (find) {
        return find;
      }
      return { groups: null };
    },
    async cmdSave() {
      try {
        this.gLoading();
        var extitem = this.bkmenu.extitem;
        extitem = extitem.map((r) => {
          let type = typeof r.groups;
          if (type == "string") r.groups = r.groups.split(",");
          r.groups = r.groups.filter((r1) => r1 != "");
          return r;
        });
        console.log(JSON.stringify(extitem));
        let body = extitem;
        // body.map((r) => {
        //   return (r.groups = r.groups.split(","));
        // });
        var res = await this.apiSaveExtitem(body);
        console.log("res", res);
        await this.refresh();
        this.gClearLoading();
      } catch (error) {
        console.log(error);
        this.gClearLoading();
      }
    },
    fmtExtitem(data) {
      var output = JSON.parse(JSON.stringify(data));
      output = output.slice(0, data.length - 1);
      output = output.filter(
        (r) => r.dispname != "" || r.imgfile != "" || r.desp != "" || r.groups.length != 0
      );
      return output;
    },
    cmdShowDetail(obj) {
      this.$refs.rFrmItemDetail.show(obj);
    },
    async refresh() {
      try {
        this.gLoading();
        var res = await this.apiGetBKMenu();
        console.log(res.data);
        this.bkmenu = res.data;
        this.initExtitem();
        this.gClearLoading();
      } catch (error) {
        console.log(error);
      }
    },
    initExtitem() {
      try {
        var extitem = this.bkmenu.extitem;
        var menuitem = this.bkmenu.menuitem;
        var array = [];
        menuitem.forEach((r) => {
          var find = extitem.find((ei) => r.ItemName == ei.itemname);
          if (find) {
            find.groups = find.groups.toString();
            array.push(find);
          } else {
            var row = {
              itemname: r.ItemName,
              dispname: "",
              imgfile: "",
              desp: "",
              groups: "",
            };
            array.push(row);
          }
        });
        this.bkmenu.extitem = array;
      } catch (error) {
        console.log(error);
      }
    },
    cmdEdit(rowIndex, obj) {
      this.$refs.rEditItem.showEdit(rowIndex, obj);
    },
    cmdShowPick(row) {
      this.$refs.rImagePick.show(row);
    },
    onPick(row, url) {
      console.log("pick", url);
      var find = this.bkmenu.menuitem.find((r) => r.ItemName == row.ItemName);
      find.ImgFile = url;
    },
    getTypeName(item) {
      var exttype = this.bkmenu.exttype;
      // console.log(item);
      var array = [];
      exttype.forEach((r) => {
        var options = r.options;
        var find = options.find(
          (r1) => r1.TypeNo == item.TypeNo && r1.ItemName == item.ItemName
        );

        if (find) {
          array.push(r.id);
        }
      });
      return array.join(",");
    },
    getItemGroups(item) {
      var extitem = this.bkmenu.extitem;
      var find = extitem.find((r) => r.itemname == item.ItemName);
      if (find) {
        return find.groups.toString();
      }
      return "";
    },
    getImgFile(item) {
      var extitem = this.bkmenu.extitem;
      var find = extitem.find((r) => r.itemname == item.ItemName);

      if (find) {
        return find.imgfile;
      }
      return "";
    },
    getFilter() {
      var menuitem = this.bkmenu.menuitem;
      if (this.keyword == "") {
        return menuitem;
      }
      // var find = extitem.find((r) => r.itemname == item.ItemName);
      // var array = menuitem.filter((r) => r.ItemName.indexOf("新鮮草莓")> -1);
      var array = menuitem.filter(
        (r) =>
          Number(r.TypeNo) == Number(this.keyword) ||
          r.ItemName.indexOf(this.keyword) > -1
      );
      return array;
      // if (find) {
      //   return find.imgfile;
      // }
      // return "";
    },
  },
};
</script>
